export const styles = {
    darkMode: false,
    colors: {
        primary: '#6380A8',
        secondary: '#006029',
        accent: '#9c27b0',
        dark: '#1d1d1d',
        positive: '#21ba45',
        negative: '#c10015',
        info: '#31ccec',
        warning: '#f2c037'
    }
};
